/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import DATE_TYPE from 'constants/dateType';
import DATE_TYPE_SALES_REPORT from 'constants/dateTypeSalesReport';

// Styles
import useStyles from './dateTypeFilter.styles';

interface StateProps {
  salesReport?: boolean;
}

type Props = StateProps;

const DateTypeFilter: React.FC<Props> = ({ salesReport }) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedStatus = useSelector(
    (state: ApplicationState) => state.reports.dateType,
  );

  const handleStatus = (status: string) => {
    dispatch(
      ReportActions.setSelectedDateType({
        selectedDateType: status,
      }),
    );
  };

  return (
    <List dense>
      {Object.values(
        salesReport ? DATE_TYPE_SALES_REPORT.TYPE : DATE_TYPE.TYPE,
      ).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleStatus(item.VALUE)}
              checked={selectedStatus === item.VALUE}
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { DateTypeFilter };
export default DateTypeFilter;
